var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isVisible,
          expression: "isVisible"
        }
      ],
      class: [
        "wrapper",
        "wrap-left",
        "h-100",
        { "open-modal-left": _vm.isOpen }
      ]
    },
    [
      _c("div", { staticClass: "modalBody bg-white w-100 h-100" }, [
        _c("div", { staticClass: "modalHeader" }, [
          _c("div", { staticClass: "title-section" }, [
            _vm._v(_vm._s(_vm.title))
          ]),
          _vm._v(" "),
          _c("div", {
            staticClass: "close-modal-button",
            on: { click: _vm.startClose }
          })
        ]),
        _vm._v(" "),
        _vm.isClient
          ? _c(
              "div",
              { staticClass: "modalContent" },
              [
                _c("client-only", [
                  _vm.loading
                    ? _c("div", { staticClass: "lb-cancel d-block" })
                    : _vm.error
                    ? _c("div", [_vm._v(_vm._s(_vm.error))])
                    : _c("div", {
                        domProps: { innerHTML: _vm._s(_vm.content) }
                      })
                ])
              ],
              1
            )
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "overlay", on: { click: _vm.startClose } })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }